(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-new-arrival-home"] && !window.DesignMode) return;
  try {
    
// setInterval(function() {
//     $('#diamond_collection_section_dekstop').slick({
//         slidesToShow: 4,
//         arrows: true,
//         dots: true,
//         centerMode: false,
//         centerPadding: '20px',
//            prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0563/5388/2146/files/custom-arrow-left.png?v=1717447089'/></button>",
//            nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0563/5388/2146/files/custom-arrow-right.png?v=1717447089'/></button>",  
//         autoplay: true, // Enable auto-scrolling
//         autoplaySpeed: 2000, // Set auto-scrolling speed to 2 seconds
//         responsive: [
//             {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 1, // Show only one slide on mobile
//                     slidesToScroll: 1, // Scroll only one slide at a time
//                     infinite: true,
//                     dots: true,
//                     arrows: true,
//                     autoplay: true, // Enable auto-scrolling
//                     autoplaySpeed: 2000 // Set auto-scrolling speed to 2 seconds
//                 }
//             }
//         ]
//     });
// }, 1000);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pickson-section"] && !window.DesignMode) return;
  try {
    
$('.c-sroll-arrow').click(function() {
  // Find the current scroll_right_inner section
      var currentSection = $(this).closest('.scroll_right_inner');

      // Find the next scroll_right_inner section
      var nextSection = currentSection.next('div');
  var dtatype = currentSection.next('div').attr('data-type');
      // If next section exists, scroll to it
      if (nextSection.length) {
        // Get the scrollable parent element
        var scrollableParent = currentSection.parent();

        // Calculate the target scroll position
        var targetScroll = scrollableParent.scrollTop() + nextSection.position().top;

         var dtatype = currentSection.next('div').attr('data-type');
       // alert(dtatype);
        if (dtatype === '2') {
       scrollableParent.animate({ scrollTop: "700px" }, 1000);
        }else{
            // Scroll to the next section with smooth behavior
        scrollableParent.animate({ scrollTop: targetScroll }, 4000);
        }
      
      }
   
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-popup-with-image"] && !window.DesignMode) return;
  try {
    
// play the targeted video (and hide the poster frame)
function videoPlay($wrapper) {
   var $iframe = $wrapper.find(".js-videoIframe");
   var src = $iframe.data("src");
   // hide poster
   $wrapper.addClass("videoWrapperActive");
   // add iframe src in, starting the video
   $iframe.attr("src", src);
   $(".home-video-close").removeClass("is-hidden");
}

// stop the targeted/all videos (and re-instate the poster frames)
function videoStop($wrapper) {
   // if we're stopping all videos on page
   if (!$wrapper) {
      var $wrapper = $(".js-videoWrapper");
      var $iframe = $(".js-videoIframe");
      // if we're stopping a particular video
   } else {
      var $iframe = $wrapper.find(".js-videoIframe");
   }
   // reveal poster
   $wrapper.removeClass("videoWrapperActive");
   // remove youtube link, stopping the video from playing in the background
   $iframe.attr("src", "");
   $(".home-video-close").addClass("is-hidden");
}

// Function to prevent double tap to play the video on touch devices. Hides poster image.
function touchVideo() {
   // Checks if #js-point-detector is made visible by the pointer:coarse media query
   var isVisible = $("#js-pointer-detector").is(":visible");
   // If it is visible...
   if (isVisible === true) {
      // Add active wrapper class
      $(".videoWrapper").addClass("videoWrapperActive");
      // Get video source
      var source = $(".js-videoIframe").data("src");
      // Load video source
      $(".js-videoIframe").attr("src", source);
   } else {
   }
}

//remove class  
  
// poster frame click event
jQuery(document).on("click", ".js-videoPoster", function(ev) {
   ev.preventDefault();
   var $poster = $(this);
   var $wrapper = $poster.closest(".js-videoWrapper");
   videoPlay($wrapper);
});

jQuery(document).ready(function() {
    jQuery(".poster-image-video .home-video-close").click(function(){
         jQuery(this).addClass("is-hidden");
        console.log("hello coder");
      jQuery(".videoWrapper").removeClass("videoWrapperActive");
      
     jQuery(".js-videoIframe").attr("src", "");
     jQuery("svg.PlayButton_module_playIcon__fc6bec57").click();
    });    
  
   touchVideo();
});

  } catch(e) { console.error(e); }
})();
})();
